import { Pipe, PipeTransform } from '@angular/core';

const statuses: Record<string, string> = {
  not_available: 'Not Available',
  maintenance_needed: 'Maintenance',
  deferred_maintenance: 'Deferred Maintenance',
  ready_for_use: 'Ready To Use',
  in_custody: 'In Custody',
  stacked: 'Stacked',
  inspection_needed: 'Inspection Needed',
  legal_hold: 'Legal Hold',
  out_of_commission: 'Out Of Commission',
  missing: 'Missing',
  pending_hse_approval: 'Pending HSE Approval',
  damaged_beyond_repair: 'Damaged Beyond Repair',
};

const statusColors: Record<string, string> = {
  not_available: '#000000',
  maintenance_needed: '#F04F0F',
  deferred_maintenance: '#e5967e',
  ready_for_use: '#5F9A7E',
  in_custody: '#448AFF',
  stacked: '#295296',
  inspection_needed: '#8B8000',
  legal_hold: '#f1e050',
  out_of_commission: '#8F00FF',
  missing: '#B01F0F',
  pending_hse_approval: '#53687A',
  damaged_beyond_repair: '#a2acb2',
};

@Pipe({
  name: 'lamAssetStatus'
})
export class LamAssetStatusPipe implements PipeTransform {
  public transform(value: any, color: boolean = false, withSecondary: boolean = false): unknown {
    if (color) {
      if (typeof value !== 'object') {
        return statusColors[value];
      }
      return statusColors[value.primaryStatusType];
    }

    if (value.primaryStatusType === undefined || value.primaryStatusType === null) {
      return statuses[value.status];
    }

    if (value.primaryStatusType === value.primaryStatusName) {
      return statuses[value.primaryStatusType];
    }

    status = value.primaryStatusName;
    if (withSecondary && value.secondaryStatusName) {
      status = `${status} - ${value.secondaryStatusName}`;
    }

    return status;
  }

  get statusTypeAndColor() {
    let result = [];
    // get key value of statusColors
    Object.keys(statusColors).forEach((status) => {
      result = [...result, status, statusColors[status]];
    });
    return result;
  }
}
